'use client';

import { ConfigProviderWrapper } from '@/app/ConfigProviderWrapper';

export function Providers({ children }: { children: React.ReactNode }) {
  return <ConfigProviderWrapper>{children}</ConfigProviderWrapper>;
}
